<div class="dibvam">
    <ng-container *ngFor="let btn of buttons">
        <button class="btn btn--text btn--secondary btn--icon btn--dku-icon" (click)="btn.action($event)" (focus)="blur($event)" [matTooltip]="btn.title"
            matTooltipPosition="above" [disabled]="(btn.enabled$ | async) === false" *ngIf="(btn.show$ | async) !== false">
            <i [ngClass]='btn.icon'></i>
        </button>
    </ng-container>
</div>
